<div *ngIf="alert" class="mt-4">
    <div [ngClass]="alert.cssClass">{{alert.message}}</div>
</div>